import { Axios } from "../../utils/axiosMiddleware";
import { SimpleCatchError } from "../../utils/Helper";

/**
 * GigMi fee breakdown for the confirm-charges modal. The server resolves the fee
 * (percent OR fixed) from the SAME fee-config the Stripe charge uses and returns
 * integer CENTS plus an admin-authored `explanation`, so the displayed total always
 * equals what the payer is actually charged.
 *
 * Two modes (mirrors mobile `fetchStripeBreakdown`):
 * - **contract mode** `{ contractId }` — a persisted contract (accept/charge flow).
 * - **amount mode** `{ amount (cents), flow_key: "homeowner"|"contractor" }` — a
 *   stateless quote before the contract exists (quick-contract CREATE flow).
 *
 * Accepts a number (contractId, back-compat) or an options object. Returns the raw
 * `{ flat_amount, gigmi_fee, total, fee_mode, fee_value, explanation }` (cents) or
 * undefined on error (caller falls back to the legacy cut).
 */
export const getFeeBreakdown = async (arg) => {
  const body =
    typeof arg === "object" && arg !== null
      ? arg.contractId
        ? { contractId: arg.contractId }
        : { amount: arg.amount, flow_key: arg.flowKey }
      : { contractId: arg };
  try {
    const response = await Axios.post("payment/fee-breakdown", body);
    return response?.data;
  } catch (e) {
    SimpleCatchError(e);
    return undefined;
  }
};
